export default __webpack_public_path__ + "static/media/Emergencia.29436ba2.svg";